import { Modal, Box, IconButton, Fade, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';



const ModalContainer = ({
    alwaysOpen,
    isOpen,
    setIsOpen,
    fullscreen,
    title,
    className,
    sx,
    children,
    onClose,
    keepMounted,
    id
}) => {
    const navigate = useNavigate();

    return (
        <Modal
            open={alwaysOpen || isOpen}
            sx={{
                zIndex: 3000,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: {
                    xs: "0.75rem",
                    sm: "1.75rem",
                    xl: "2.75rem"
                },
                py: "1.5rem"
            }}
            keepMounted={keepMounted === undefined ? true : Boolean(keepMounted)}
            onClick={alwaysOpen ? () => { } : onClose ? () => onClose() : () => setIsOpen(false)}
        >
            <Fade in={alwaysOpen || isOpen}>
                <Box className={`bg-color
                    border-2 border-black
                    rounded-lg max-h-full overflow-auto
                    dir-ltr relative
                    ${fullscreen ? "w-full h-full" : "container mx-auto max-w-screen-md"}
                    ${className || ""}`}
                    onClick={(ev) => ev.stopPropagation()}
                    id={id}
                >
                    <Box
                        className="sticky top-0 right-0
                        flex justify-between items-center
                        w-full h-10 ps-4 pe-2 py-8 overflow-hidden
                        border-b border-black bg-gray-200"
                        sx={{
                            zIndex: 3000
                        }}
                    >
                        <Typography variant="h6"
                            sx={{
                                wordBreak: "break-all"
                            }}
                        >
                            {title}
                        </Typography>
                        <IconButton
                            onClick={alwaysOpen ? () => navigate(-1) : onClose ? () => onClose() : () => setIsOpen(false)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            px: {
                                xs: "1.75rem",
                                sm: "2.75rem",
                                md: "3.75rem"
                            },
                            pt: "1.75rem",
                            pb: "2rem",
                            ...sx
                        }}
                    >
                        {children}
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}

export default ModalContainer;
